/**
 * use current store to set / output dependable from special process data ONLY on single response page
 */

const state = {
  tabsAvailable: []
};

const getters = {
  tabsAvailable(state) {
    return state.tabsAvailable;
  }
};

const mutations = {
  setTabsAvailable(state, { tabsAvailable }) {
    state.tabsAvailable = tabsAvailable;
  },

  ADD_TAB_AVAILABLE: (state, payload) => {
    const index = state.tabsAvailable.findIndex(x => x.name === payload);

    if (index === -1) {
      state.tabsAvailable.push({ name: payload });
    }
  },

  REMOVE_TAB_AVAILABLE: (state, payload) => {
    const index = state.tabsAvailable.findIndex(x => x.name === payload);

    if (index >= 0) {
      state.tabsAvailable.splice(index, 1);
    }
  }
};

const actions = {
  setTabsAvailable({ commit }, data) {
    commit('setTabsAvailable', data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
